import { Document } from '@contentful/rich-text-types';
import { FC } from 'react';
import classNames from 'classnames';
import MainBodyToReact from './MainBodyToReact';
import { TPosition } from '@/types/types';

interface ContentBlockProps {
    title?: string;
    titlePosition?: TPosition;
    subtitle?: string;
    subtitlePosition?: TPosition;
    summary?: string | Document;
    summaryPosition?: TPosition;
    fullWidth?: boolean;
    inspectorProps?: any;
    fieldId?: string;
    summaryId?: string;
}

const ContentBlock: FC<ContentBlockProps> = ({
    inspectorProps = () => ({}),
    title,
    titlePosition = 'Center',
    subtitle,
    subtitlePosition = 'Center',
    summary,
    summaryPosition = 'Center',
    fullWidth = false,
    fieldId,
    summaryId,
}) => {
    return (
        <div className="tw-w-full tw-flex tw-flex-col tw-items-center">
            {subtitle && (
                <h4
                    className={classNames(
                        'tw-text-[14px] md:tw-text-[12px] lg:tw-text-[14px] tw-uppercase tw-text-pink1 tw-font-gotham-medium tw-pb-[8px] tw-mt-[40px]',
                        {
                            'tw-self-start': subtitlePosition === 'Left',
                            'tw-self-center': subtitlePosition === 'Center',
                            'tw-self-end': subtitlePosition === 'Right',
                        },
                    )}
                    {...inspectorProps({ fieldId: 'subtitle' })}
                >
                    {subtitle}
                </h4>
            )}
            {title && (
                <h3
                    className={classNames(
                        'tw-text-[#003865] tw-text-[26px] lg:tw-text-[32px] tw-font-gotham-bold tw-pb-[12px]',
                        {
                            'tw-self-start': titlePosition === 'Left',
                            'tw-self-center ': titlePosition === 'Center',
                            'tw-self-end': titlePosition === 'Right',
                        },
                    )}
                    {...inspectorProps({ fieldId: 'title' })}
                >
                    {title}
                </h3>
            )}
            {summary && (
                <div
                    className={classNames({
                        'tw-self-start': summaryPosition === 'Left',
                        'tw-self-center tw-text-center': summaryPosition === 'Center',
                        'tw-self-end tw-text-end': summaryPosition === 'Right',
                        'tw-w-full': fullWidth,
                        'tw-max-w-[690px]': !fullWidth,
                    })}
                    {...inspectorProps({ fieldId: 'content' })}
                >
                    {typeof summary === 'string' ? (
                        <p className="tw-text-[#484654] tw-text-[16px] md:tw-text-[14px] lg:tw-text-[16px] tw-leading-7 tw-font-gotham-book tw-py-[10px]">
                            {summary}
                        </p>
                    ) : (
                        <MainBodyToReact body={summary} fieldId={fieldId} id={summaryId} />
                    )}
                </div>
            )}
        </div>
    );
};

export default ContentBlock;
